import { IsEmail, IsOptional, IsUUID } from 'class-validator';

export class UserUpdateDto {
  @IsEmail()
  email!: string;

  @IsUUID()
  @IsOptional()
  userId?: string;
}
